import { logWarning } from '@databases/logs';
import { container } from '@databases/service-container';

import type { PluginKey } from '.';

export function isPluginEnabled(pluginKey: PluginKey): boolean {
  try {
    const pluginsManager = container.resolve('PluginsManager');
    return pluginsManager.isPluginEnabled(pluginKey);
  } catch (e) {
    logWarning(new Error(`Plugin check failed for '${pluginKey}': ${e}`));
    return false;
  }
}
